// Builder konfiguračních kódů (QR payload pro HW čtečky / mobilní čtečku).
// Formát viz docs/superpowers/plans/2026-05-28-config-qr-codes-inspector.md

export function buildTicketsetsCode(ids: (number | string)[]): string {
    return `TICKETS:T:${ids.join(',')};`
}

export function buildZonesCode(ids: (number | string)[]): string {
    return `TICKETS:Z:${ids.join(',')};`
}

export function buildLoginCode(username: string, password: string): string {
    return `LOGIN:U:${username};P:${password};`
}

// Spojí dílčí příkazy svislítkem (např. login + výběr sad do jednoho QR).
// Falsy hodnoty (prázdný login) se odfiltrují.
export function joinCommands(commands: string[]): string {
    return commands.filter(Boolean).join('|')
}
